// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"33339b89","453":"37b7a98d","455":"016b7be9"}[chunkId] + ".chunk.js";
};